import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Props = {
  label?: string;
  archived?: boolean;
  hidden?: boolean;
};

export const DropdownOptionLabel = ({ label = '', archived = false, hidden = false }: Props) => {
  const disabled = archived || hidden;
  return (
    <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
      {archived && <Icon name='archive-small' color='subdued' css={{ flexShrink: 0 }} />}
      <Text as='span' color={disabled ? 'subdued' : 'default'}>
        {label}
      </Text>
    </div>
  );
};
